import React, { PropsWithChildren } from "react"
import { Card, SxProps, Theme } from "@mui/material"

export type PrimiveCardProps = PropsWithChildren<{
	elevation?: number
	sx?: SxProps<Theme>
}>

export const PrimitiveCard = ({
	children,
	...props
}: PrimiveCardProps) => {
	return (
		<Card
			{...props}
		>
			{children}
		</Card>
	)
}